import * as B from '@blueprintjs/core';
import React from 'react';

/**
 * Spinner that is centered within its parent element.
 */

export const CenteredSpinner: React.FunctionComponent = () => (
  <div style={{display: 'flex', justifyContent: 'center', height: '100%'}}>
    <B.Spinner />
  </div>
);

export default CenteredSpinner;
